import React from "react";
import { gql } from '@apollo/client';
import { Query } from "react-apollo";
import './index.css';

const Page: React.FC = () => {
    const pageName = document.location.pathname === '/' ? 'posts' : document.location.pathname.replace(/\//g, '');
    const query = gql`
query GetPageByID($id:ID!){
  page(id:$id, idType:URI){
    title
    content
    slug
    uri
  }
}`;
    const variables = {
        id: pageName
    }
    return (
        <div>
            <Query query={query} variables={variables}>
                {({ loading, error, data }) => {
                    
                    if (loading) return <div id="loading"><p>Loading...</p></div>;
                    if (error) return <div id="error"><p>Error: {error.message}</p></div>;
                    return (
                        <div id="page">
                            <h1>{data?.page?.title}</h1>
                            <div dangerouslySetInnerHTML={{ __html: data?.page?.content }} />
                        </div>
                    );
                }}
            </Query>
        </div>
    );
};

export default Page;